import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';
import { Link } from 'react-router-dom';
import React, { useRef } from "react";
import PDFModal from '../../component/PDFModal.js';
//import IMUUserCreate from './IMUUserCreate.js';

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';


export default function IPOVendorlist() {

  const tableRef = useRef(null);


  {/*------------------------------------*/ }
  /* CUSTOM DATA TABLE BEGIN HERE */

  const [tableData, setTableData] = useState([]);

  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total_count, setTotal] = useState(null);

  const [reload, setReload] = useState(false);


  const [forwardUserID, setForwardUserID] = useState(false);
  const [isForwardUser, setForwardUser] = useState(false);


  const [isDeleteUser, setDeleteUser] = useState(false);
  const [deleteUserID, setDeleteUserID] = useState(false);
  const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);



  /* CUSTOM DATA TABLE END HERE */


  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/college/");
  }


  let cid = localStorage.getItem("collegeid");
  let collegename = localStorage.getItem("username");


  useEffect(() => {


    const getCollegeUsersList = async () => {
      try {
        const response = await http.post(`/College/listVendor`);


        //console.log("res", response.data.data);
        setTableData(response.data.data);

      }
      catch (error) {

        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };


    getCollegeUsersList();


  }, [reload]);


  /* DATA TABLE  */

  const handleSearchInputChange = (event) => {

    setSearchQuery(event.target.value);
  };

  const handleSort = (column) => {

    const newSortBy = {
      column,
      direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortBy(newSortBy);
  };

  //sorting this page : combined column
  const getSortValue = (item, column) => {
    if (column === 'vendor_details') {
      return `${item.vendor_mobileno ?? ''} ${item.vendor_email ?? ''} ${item.vendor_address ?? ''}`.toLowerCase();
    }
    return (item[column] ?? '').toString().toLowerCase();
  };

  useEffect(() => {
    const search = searchQuery.toLowerCase();

    let data = [...tableData].filter(item =>
      (item.vendor_name ?? '').toLowerCase().includes(search) ||
      (item.vendor_email ?? '').toLowerCase().includes(search) ||
      (item.vendor_mobileno ?? '').toLowerCase().includes(search) ||
      (item.vendor_address ?? '').toLowerCase().includes(search) ||
      (item.college_name ?? '').toLowerCase().includes(search) ||
      (item.status ?? '').toLowerCase().includes(search)
    );

    //SORTING
    data.sort((a, b) => {
      const valA = getSortValue(a, sortBy.column);
      const valB = getSortValue(b, sortBy.column);

      if (sortBy.direction === 'asc') {
        return valA > valB ? 1 : -1;
      } else {
        return valA < valB ? 1 : -1;
      }
    });

    const itemsPerPage = 50;
    const startIndex = (currentPage - 1) * itemsPerPage;

    setfilteredAndSortedData(data.slice(startIndex, startIndex + itemsPerPage));
    setTotalPages(Math.ceil(data.length / itemsPerPage));
    setTotal(data.length);

  }, [searchQuery, sortBy, tableData, currentPage]);


  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };



  const handleGeneratePDFNew = async () => {
    // setLoading(true);
    try {
      const response = await http.get('/College/vendorListpdfDownload', {
        responseType: 'blob', // Expect binary response
      });

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute(
          'download',
          `InternshipProvidingOrganisation_list.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // setLoading(false);
        toast.success('PDF generated successfully');
      }
    } catch (error) {
      //console.log("error",error);
      // setLoading(false);
      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);

      }
      else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
        toast.error(error.response.data.message);
      }
      else {
        console.error('Error generating PDF:', error);
        toast.error('Error generating PDF');
      }
    }
  };

  const handleForwardUser = (userid) => {
    setForwardUserID(userid);
    setForwardUser(true);
  }

  const handleForwardSuccess = async () => {
    http
      .post('/College/principalVendorApprove', {

        id: forwardUserID,

      })
      .then((response) => {

        if (response.data.status_code === "true") {

          setForwardUser(false);

          sessionStorage.setItem("message", "Approved successfully");
          toast.success("Approved successfully");
          setReload(!reload);

        }
      })
      .catch((error) => {
        setForwardUser(false);

        const status = error.response?.data?.http_status;
        const code = error.response?.data?.status_code;
        const message = error.response?.data?.message || "An error occurred";

        if (code === "ERR_COURSE" && status === 500) {
          toast.error("Deletion not allowed. The user has courses that are already approved.");
        } else if (code === "ERR_COURSE2" && status === 500) {
          toast.error("Action not allowed after scripts have been received by your team.");
        } else if (status === 500 || code === "ERR5") {
          toast.error("No user found");
        } else if (status === 403 && code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/college/"), 5000);
        } else {
          toast.error(message);
        }
      });
  };
  const handleForwardCancel = () => {
    setForwardUser(false);
  }

  const handleDeleteUser = (userid) => {
    setDeleteUserID(userid);
    setDeleteUser(true);
  }

  const handleedit = (userid) => {

    navigate(`/ino/imuuseredit/${userid}`);

  }
  const handleDeleteCancel = () => {
    setDeleteUser(false);
  }


  const handleCloseCreateForm = () => {
    setShowCreateForm(false);
    setReload(!reload); // Refresh the list when closing
  };

  const handleViewDocument = async (encryptedFile) => {
    if (encryptedFile) {
      try {
        const res = await http.get(`College/secure_ino_pdf/${encryptedFile}`, {
          responseType: 'blob'
        });

        const blob = new Blob([res.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        setPdfUrl(url);
        setIsPDFModalOpen(true);
      } catch (error) {
        console.error('Error loading PDF:', error);
        toast.error('Failed to load PDF document');
      }
    }
  };

  const handleClosePDFModal = () => {
    setIsPDFModalOpen(false);
    if (pdfUrl) {
      window.URL.revokeObjectURL(pdfUrl);
      setPdfUrl(null);
    }
  };

  const handleDeleteSuccess = async () => {
    http
      .post('/College/principalVendorRevert', {

        id: deleteUserID,

      })
      .then((response) => {

        if (response.data.status_code === "true") {

          setDeleteUser(false);
          sessionStorage.setItem("message", "Reverted successfully");
          toast.success("Reverted successfully");
          setReload(!reload);

        }
      })
      .catch((error) => {

        const status = error.response?.data?.http_status;
        const code = error.response?.data?.status_code;
        const message = error.response?.data?.message || "An error occurred";
        setDeleteUser(false);
        if (code === "ERR_COURSE" && status === 500) {
          toast.error("Deletion not allowed. The user has courses that are already approved.");
        } else if (code === "ERR_COURSE2" && status === 500) {
          toast.error("Action not allowed after scripts have been received by your team.");
        } else if (status === 500 || code === "ERR5") {
          toast.error("No user found");
        } else if (status === 403 && code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/college/"), 5000);
        } else {
          toast.error(message);
        }
      });
  };





  return (
    <>
      <ToastContainer />

      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>Internship Providing Organisation</h5>
                    </div>
                  </div>
                  <div className="card-body">


                    <div className="table-responsive">

                      <div className="row align-items-center pdg18">
                        {/* Left 6 columns */}
                        <div className="col-md-8">

                        </div>

                        {/* Right 6 columns */}
                        <div className="col-md-4 d-flex justify-content-end">
                          <div className="d-flex gap-2">
                            {/* <button
                              className="btn custom-btn btn-primary common-btn d-inline-flex align-items-center justify-content-center"
                              onClick={() => setShowCreateForm(true)}
                              title="Add New User"
                            >
                              <i className="bi bi-plus-square ctm-btn-sz m-r-5"></i>New
                            </button> */}

                            <button
                              className="btn btn-primary common-btn d-inline-flex align-items-center justify-content-center pdf-btn"
                              onClick={() => handleGeneratePDFNew()}
                              title="Download to PDF"
                            >
                              <i className="bi bi-arrow-down-square ctm-btn-sz"></i>
                            </button>

                          </div>
                        </div>
                      </div>

                      <div className='row'>

                        <div className='col-md-6 wdt' >
                          <p>
                            Showing {(currentPage - 1) * 50 + 1}{''}-
                            {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                          </p>
                        </div>
                        <div className='col-md-6 wdt' align='right'>
                          <input
                            type="text"
                            value={searchQuery}
                            onChange={handleSearchInputChange}
                            placeholder="Search..."
                            className='form-control'
                          /></div></div>
                      <div class="table-containerq" style={{ overflowX: 'unset' }}>

                        <table className="display dataTable table-striped table-bordered ex-v-table " ref={tableRef}>
                          <thead>
                            <tr className="bg-primary">

                              <th onClick={() => handleSort('id')} scope="col" data-label="APAAR Id" width="8%">Sl No &nbsp;
                                {renderSortIcon('id')} </th>
                              <th onClick={() => handleSort('vendor_name')} scope="col" data-label="User Type" width="" >Name &nbsp;
                                {renderSortIcon('vendor_name')} </th>
                              <th onClick={() => handleSort('vendor_details')} scope="col" data-label="User Type" width="" >Contact Details &nbsp;
                                {renderSortIcon('vendor_details')} </th>

                              {/* <th onClick={() => handleSort('vendor_email')} scope="col" data-label="User Type" width="" >Email &nbsp;
                                {renderSortIcon('vendor_email')} </th>

                              <th onClick={() => handleSort('vendor_phoneno')} scope="col" data-label="User Type" width="" >Phone No &nbsp;
                                {renderSortIcon('vendor_phoneno')} </th>

                              <th onClick={() => handleSort('vendor_address')} scope="col" data-label="User Type" width="" >Address &nbsp;
                                {renderSortIcon('vendor_address')} </th> */}

                              <th scope="col" data-label="Description" width="">Description</th>
                              <th scope="col" data-label="Description" width="">Attachments</th>
                              <th scope="col" data-label="Description" width="">Status</th>

                              <th scope="col" data-label="Action" width="">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredAndSortedData.length > 0 ? (() => {


                              // Sort so items of same group (discipline/type/ACS) stay together
                              const sortedData = [...filteredAndSortedData].sort((a, b) => {
                                const keyA = `${a.discipline_name ?? ''}-${a.college_discipline_type ?? ''}-${a.user_type_name ?? ''}`;
                                const keyB = `${b.discipline_name ?? ''}-${b.college_discipline_type ?? ''}-${b.user_type_name ?? ''}`;
                                return keyA.localeCompare(keyB);
                              });


                              let serialNumber = (currentPage - 1) * 50 + 1;

                              // Render rows with group headers
                              return sortedData.map((item, index) => {


                                return (
                                  <React.Fragment key={`${item.id}-${index}`}>

                                    <tr className="grouped-row">
                                      <td>{serialNumber++}</td>

                                      <td>{item.vendor_name}</td>

                                      <td><b>Phone:</b>{item.vendor_mobileno}<br />
                                        <b>Email:</b>{item.vendor_email}<br />

                                        <b>Address:</b>{item.vendor_address}</td>


                                      <td>
                                        {item.description ? (
                                          <span
                                            title={item.description.length > 50 ? item.description : ''}
                                            style={{
                                              cursor: item.description.length > 50 ? 'help' : 'default',
                                              display: 'inline-block',
                                              maxWidth: '200px'
                                            }}
                                          >
                                            {item.description.length > 50
                                              ? `${item.description.substring(0, 50)}...`
                                              : item.description
                                            }
                                          </span>
                                        ) : (
                                          null
                                        )}
                                      </td>

                                      <td className="text-center">
                                        {item.document?.[0]?.encryptedFile ? (
                                          <div
                                            className="pdf-icon-box"
                                            onClick={() => handleViewDocument(item.document[0].encryptedFile)}
                                            title="View PDF"
                                          >
                                            <i className="bi bi-file-earmark-pdf-fill text-danger"></i>
                                          </div>
                                        ) : (
                                          <span className="text-muted text-center">—</span>
                                        )}

                                      </td>


                                      <td>
                                        {item.revert_status === "1" && item.status === "created" ? (
                                          <span className="badge bg-danger">
                                            Principal Reverted
                                          </span>
                                        ) : item.status === "active" ? (
                                          <span className="badge bg-success">
                                            Principal Approved
                                          </span>
                                        ) : item.status === "forwarded" ? (
                                          <span className="badge bg-info">
                                            INO Forwarded
                                          </span>
                                        ) : item.status === "created" ? (
                                          <span className="badge bg-warning text-dark">
                                            Created - Not Forwarded
                                          </span>
                                        ) : (
                                          <span className="badge bg-secondary">
                                            Unknown
                                          </span>
                                        )}
                                      </td>
                                      <td>

                                        <div className="d-flex justify-content-center gap-1">

                                          {/* {item.document?.[0]?.encryptedFile ? (
                                            <button
                                              className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1 action-btn-compact"
                                              onClick={() => handleViewDocument(item.document[0].encryptedFile)}
                                              title="View Document"
                                            >
                                              <i className="bi bi-eye-fill"></i>
                                            </button>
                                          ) : null} */}

                                          {/* {(item.status === "created") && (

                                            <button
                                              className="btn btn-sm btn-outline-warning btn-sm d-flex align-items-center gap-1 action-btn-compact"
                                              onClick={() => handleedit(item.id)}
                                              title="Edit"
                                            >
                                              <i class="fa fa-edit"></i>

                                            </button>
                                            )} */}

                                          {(item.status === "forwarded") && (

                                            <button
                                              className="btn btn-sm btn-outline-info btn-sm d-flex align-items-center gap-1 action-btn-compact"
                                              onClick={() => handleForwardUser(item.id)}
                                              title="Approve"
                                            >
                                              <i className="fa fa-check-double"></i>

                                            </button>
                                          )}


                                          {(item.status === "forwarded") && (

                                            <button
                                              className="btn btn-sm btn-outline-danger btn-sm d-flex align-items-center gap-1 action-btn-compact"
                                              onClick={() => handleDeleteUser(item.id)}
                                              title="Revert"
                                            >
                                              <i className="fa fa-undo-alt"></i>

                                            </button>
                                          )}
                                          {((item.status === "active") || (item.revert_status === "1" && item.status === "created")) && (

                                            <span className="text-muted text-center">—</span>

                                          )}
                                        </div>


                                      </td>
                                    </tr>
                                  </React.Fragment>
                                );
                              });
                            })() : (
                              <tr>
                                <td colSpan="8" className="text-center">No data found</td>
                              </tr>
                            )}
                          </tbody>


                        </table>
                      </div>

                      {totalPages > 1 && (
                        <nav aria-label="..." style={{ cursor: "pointer" }}>
                          <ul className="pagination justify-content-center">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                            </li>
                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                            </li>
                            {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                            {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                              <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                              </li>
                            ))}
                            {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                            </li>

                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                            </li>
                          </ul>
                        </nav>
                      )}


                      {/*  Forward User */}
                      <div className={`modal fade show ${isForwardUser ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                          <div className="modal-content">
                            <div className="modal-body">
                              <div className="modal-toggle-wrapper">

                                <h4 className="text-center pb-2">Are you sure you want to Approve?</h4>
                                <p className="text-center">This action cannot be undone.Please confirm if you want to proceed ?</p>
                                <div className="d-flex justify-content-center mt-3">
                                  <button className="btn btn-danger mx-2" onClick={() => handleForwardSuccess()}>Approve</button>
                                  <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleForwardCancel()}>Cancel</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*  Forward User End */}
                      {/*  Delete User */}
                      <div className={`modal fade show ${isDeleteUser ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                          <div className="modal-content">
                            <div className="modal-body">
                              <div className="modal-toggle-wrapper">

                                <h4 className="text-center pb-2">Are you sure you want to revert?</h4>
                                <p className="text-center">This action cannot be undone. Please confirm if you want to proceed to revert.</p>
                                <div className="d-flex justify-content-center mt-3">
                                  <button className="btn btn-danger mx-2" onClick={() => handleDeleteSuccess()}>Revert</button>
                                  <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleDeleteCancel()}>Cancel</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*  Delete User End */}

                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>

      <PDFModal
        isOpen={isPDFModalOpen}
        onClose={handleClosePDFModal}
        pdfUrl={pdfUrl}
        fileName={pdfUrl ? 'Document' : ''}
      />
    </>
  );
}
